import Icon from 'veui/components/Icon'
import { IconFeed } from 'dls-icons-vue'

Icon.register('feed', IconFeed)
